import React from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  /** Optional search input rendered on the right before actions */
  search?: React.ReactNode;
  /** Optional breadcrumb/back link slot rendered above the title */
  eyebrow?: React.ReactNode;
}

export function PageHeader({ title, subtitle, actions, search, eyebrow }: PageHeaderProps) {
  return (
    <div className="ui-page-header">
      <div className="ui-page-header-text">
        {eyebrow && <div className="ui-page-header-eyebrow">{eyebrow}</div>}
        <h1 className="ui-page-header-title">{title}</h1>
        {subtitle && <p className="ui-page-header-subtitle">{subtitle}</p>}
      </div>
      {(search || actions) && (
        <div className="ui-page-header-actions">
          {search}
          {actions}
        </div>
      )}
    </div>
  );
}

export default PageHeader;
